/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaListApiResponse,
    MediaListApiResponseFromJSON,
    MediaListApiResponseFromJSONTyped,
    MediaListApiResponseToJSON,
} from './MediaListApiResponse';
import {
    PrtimesMediaListsSelectedMediaListsLogRecordResponseAllOf,
    PrtimesMediaListsSelectedMediaListsLogRecordResponseAllOfFromJSON,
    PrtimesMediaListsSelectedMediaListsLogRecordResponseAllOfFromJSONTyped,
    PrtimesMediaListsSelectedMediaListsLogRecordResponseAllOfToJSON,
} from './PrtimesMediaListsSelectedMediaListsLogRecordResponseAllOf';

/**
 * response of POST /prtimes_media_lists/{media_list_id}/selected_media_lists/logs
 * @export
 * @interface PrtimesMediaListsSelectedMediaListsLogRecordResponse
 */
export interface PrtimesMediaListsSelectedMediaListsLogRecordResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PrtimesMediaListsSelectedMediaListsLogRecordResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PrtimesMediaListsSelectedMediaListsLogRecordResponse
     */
    message: string;
    /**
     * 記録された選択済みリストの履歴ID
     * @type {number}
     * @memberof PrtimesMediaListsSelectedMediaListsLogRecordResponse
     */
    logId: number;
}

export function PrtimesMediaListsSelectedMediaListsLogRecordResponseFromJSON(json: any): PrtimesMediaListsSelectedMediaListsLogRecordResponse {
    return PrtimesMediaListsSelectedMediaListsLogRecordResponseFromJSONTyped(json, false);
}

export function PrtimesMediaListsSelectedMediaListsLogRecordResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListsSelectedMediaListsLogRecordResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'logId': json['log_id'],
    };
}

export function PrtimesMediaListsSelectedMediaListsLogRecordResponseToJSON(value?: PrtimesMediaListsSelectedMediaListsLogRecordResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'log_id': value.logId,
    };
}

